export const Constants = {
    TOAST_TIME_OUT: 1500,
    ALERT_PROMO_CODE: "Please enter a valid promo code. Promo code should contain only letters and numbers",
    ALERT_SELECT_SESSION_LENGTH: "Please select the session length.",
    ALERT_ENTER_SESSIONS: "Please enter the number of sessions.",
    ALERT_ENTER_PRICE: "Please enter the price.",
    SESSION_DURATIONS: [15, 30, 45, 60],
    STATUS_CONFIRMED: "CONFIRMED",
    STATUS_ACCEPTED: "ACCEPTED",
    VPT_PRICE_GROUP_KEYS: ["flexit", "other"],
    SOURCE: "super-admin",
    ADMIN_ACCESS_LEVELS: { TIER_1: 1, TIER_2: 2, TIER_3: 3 },
    ERR0R_INVALID_AUTH_TOKEN: "Invalid Auth Token",
    DEFAULT_PAGINATION_COUNT: 25,
    STATE_VPT_HOME: "VPT_HOME",
    STATE_VPT_BOOKINGS: "VPT_BOOKINGS",
    STATE_VPT_TRAINERS: "VPT_TRAINERS",
    ENTER_VALID_REMAINING_USAGE_LIMIT: "Please enter the valid remainingUsageLimit. It should be lesser than the total purchased session.",
    STATE_USERS: "USERS",
    STATE_PROMOCODES: "PROMOCODES",
    USER_TRAINER_SESSION_STATUS_ARR: [
        { value: 'CONFIRMED', label: 'CONFIRMED' },
        { value: 'CANCELLED', label: 'CANCELLED' },
        { value: 'RESCHEDULED', label: 'RESCHEDULED' },
        { value: 'RESCHEDULE_REQUESTED', label: 'RESCHEDULE_REQUESTED' },
        { value: 'COMPLETED', label: 'COMPLETED' },
    ],
}

export const TimeFormats = {
    time_am_pm: "hh:mm A",
    date: "YYYY-MM-DDTHH:mm",
    bookingTimeFormat: "MM/DD/YYYY hh:mm:ss a Z"
}

export const VPTSessionLengths = [
    15,
    30,
    45,
    60
]